import type { FormProps } from "antd"
import { Form, message } from "antd"
import Title from "antd/es/typography/Title"
import { useState } from "react"
import { useNavigate } from "react-router"
import { Paths } from "~/constants"
import { JobDetailAttributes } from "~/types/types"
import { t } from "../../../languages/i18n"
import { addJobDetail } from "../service/jobDetail"
import JobDetailForm from "./JobDetailForm"
import Publish from "./Publish"

const AddNewJobDetail = () => {
  const [form] = Form.useForm()
  const navigate = useNavigate()
  const [status, setStatus] = useState("Draft")
  const [publishDate, setPublishDate] = useState<string | null>(null)
  const onFinish: FormProps<JobDetailAttributes>["onFinish"] = async values => {
    const dataPayload = {
      ...values,
      publishedAt: status === "Draft" ? null : new Date().toISOString(),
    }

    try {
      await addJobDetail({ data: dataPayload })

      message.success("Job detail added successfully!")

      form.resetFields()

      navigate(Paths.JOB_DETAIL.LIST.PATH)
    } catch (error) {
      message.error("Failed to add job detail. Please try again.")
    }
  }

  const onFinishFailed: FormProps<JobDetailAttributes>["onFinishFailed"] = () => {}

  return (
    <div className="p-4">
      <Title level={2} className="m-0">
        {t("Add New Job Detail")}
      </Title>
      <div className="flex justify-between gap-5">
        <JobDetailForm form={form} onFinish={onFinish} onFinishFailed={onFinishFailed} />
        <div className=" w-[22%] pt-2 ">
          <Publish
            onSubmit={form.submit}
            isCreateEdit={true}
            setStatus={setStatus}
            status={status}
            setPublishDate={setPublishDate}
            setLanguages={() => {}}
            language=""
          />
        </div>
      </div>
    </div>
  )
}

export default AddNewJobDetail
